<template>

  <div class="group" style="margin-bottom: 0;" :ref="refs['widthGroup']" data-id="widthGroup">

    <div class="group-header">
      <div class="group-title">What are the measurements of the wardrobe?</div>
      <div class="group-help">Not sure? <a href="/support/how-to-measure/" target="_blank">See how to measure.</a></div>
    </div>

    <div class="group-inputs">

      <div class="group-input l_height" :ref="refs['heightGroup']">

        <Input
        key="height"
        field-label="Ceiling Height"
        field-name="height"
        field-type="number"
        :init-value=builder.currentItem.specs.height
        :max=builder.currentProductStructure.height.max
        :min=builder.currentProductStructure.height.min
        :required="true"
        scope="specs"
        @update-value="updateValue"
        @update-non-standard="updateNonStandard"
        ></Input>

      </div>

      <div class="group-input l_x l_shrink">
        <svg class="icon"><use href="#cross"></use></svg>
      </div>

      <div class="group-input" :ref="refs['widthGroup']">

        <Input
        key="width"
        field-label="Width"
        field-name="width"
        field-type="number"
        :init-value=builder.currentItem.specs.width
        :max=builder.currentProductStructure.width.max
        :min=builder.currentProductStructure.width.min
        :required="true"
        scope="specs"
        @update-value="updateValue"
        @update-non-standard="updateNonStandard"
        ></Input>

      </div>

    </div>

    <div class="group-footer l_text-center">

      <div class="styledcheckbox group-checkbox">
        <input
          type="checkbox"
          name="levelsOut"
          id="levelsOut"
          value="1"
          :true-value="true"
          :false-value="false"
          v-model="builder.currentItem.specs.levelsOut" />
        <label for="levelsOut">
          <span class="checkbox-value">My levels are out more than 8mm</span>
        </label>
      </div>

    </div>

    <div class="group-footer l_text-center">

      <p>Overall Depth:&nbsp;&nbsp;600mm</p>

      <!-- <small>To maintain an economical product all internal board is 442mm and the overall depth is 600mm.</small> -->

    </div>

    <!-- <div class="group-header" style="margin-top: 20px;" v-if="builder.currentItem.specs.levelsOut">
      <div class="group-title">Levels Measurements</div>
      <div class="group-help"><a href="/support/how-to-measure/" target="_blank">View levels measurement guide.</a></div>
    </div>

    <div class="group-footer" style="font-size: 80%;" v-if="builder.currentItem.specs.levelsOut">

      <p>You're being asked for additional measurements because your selected levels were out by more than 8mm. We must get these measurements to ensure the doors fit correctly, and we can supply additional scribes if needed.</p>

    </div>

    <div class="group-header" style="margin-top: 20px;" v-if="builder.currentItem.specs.levelsOut">
      <div class="builderinput-label l_measurement-label l_base-color">Widths</div>
    </div>

    <div class="group-inputs" v-if="builder.currentItem.specs.levelsOut">

      <div class="group-input" :ref="refs['topWidthGroup']">

        <Input
        key="widthTop"
        field-label="Top Width"
        field-name="widthTop"
        field-type="number"
        :init-value=builder.currentItem.specs.widthTop
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="updateValue"
        ></Input>

      </div>

      <div class="group-input" :ref="refs['middleWidthGroup']">

        <Input
        key="widthMiddle"
        field-label="Middle Width"
        field-name="widthMiddle"
        field-type="number"
        :init-value=builder.currentItem.specs.widthMiddle
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="updateValue"
        ></Input>

      </div>

      <div class="group-input" :ref="refs['bottomWidthGroup']">

        <Input
        key="widthBottom"
        field-label="Bottom Width"
        field-name="widthBottom"
        field-type="number"
        :init-value=builder.currentItem.specs.widthBottom
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="updateValue"
        ></Input>

      </div>

    </div>

    <div class="group-header" style="padding-top: 20px; border-top: 2px solid #ccc; margin-top: 20px;" v-if="builder.currentItem.specs.levelsOut">
      <div class="builderinput-label l_measurement-label l_base-color">Heights</div>
    </div>

    <div class="group-inputs" style="margin-top: 20px;" v-if="builder.currentItem.specs.levelsOut">

      <div class="group-input" :ref="refs['leftHeightGroup']">

        <Input
        key="heightLeft"
        field-label="Left Height"
        field-name="heightLeft"
        field-type="number"
        :init-value=builder.currentItem.specs.heightLeft
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="updateValue"
        ></Input>

      </div>

      <div class="group-input" :ref="refs['middleHeightGroup']">

        <Input
        key="heightMiddle"
        field-label="Middle Height"
        field-name="heightMiddle"
        field-type="number"
        :init-value=builder.currentItem.specs.heightMiddle
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="updateValue"
        ></Input>

      </div>

      <div class="group-input" :ref="refs['rightHeightGroup']">

        <Input
        key="heightRight"
        field-label="Right Height"
        field-name="heightRight"
        field-type="number"
        :init-value=builder.currentItem.specs.heightRight
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="updateValue"
        ></Input>

      </div>

    </div>

    <div class="group-header" style="padding-top: 20px; border-top: 2px solid #ccc; margin-top: 20px;" v-if="builder.currentItem.specs.levelsOut">
      <div class="builderinput-label l_measurement-label l_base-color">Run-out</div>
    </div>

    <div class="group-inputs" v-if="builder.currentItem.specs.levelsOut">

      <div class="group-input" :ref="refs['topWidthGroup']">

        <Select-Input
        key="runOutDirection"
        field-label="Direction"
        field-name="runOutDirection"
        field-type="select"
        show-label="true"
        :init-value=builder.currentItem.specs.runOutDirection
        :default-value="builder.runOutDirectionsOptions[0].id"
        :required="true"
        options-source="runOutDirectionsOptions"
        custom-class="builderinput l_measurement"
        scope="specs"
        @update-value="updateValue"
        ></Select-Input>

      </div>

      <div class="group-input" :ref="refs['middleWidthGroup']">

        <Input
        key="runOutAmount"
        field-label="Amount"
        field-name="runOutAmount"
        field-type="number"
        :init-value=builder.currentItem.specs.runOutAmount
        :required="true"
        custom-class="l_measurement"
        scope="specs"
        @update-value="updateValue"
        ></Input>

      </div>

    </div> -->

    <!-- <div class="group-footer l_text-center" v-if="builder.currentItem.specs.levelsOut">

      <img src="/images/wardrobe-levels-measure-guide.svg" style="width: 100%; max-width: 500px; margin: 0 auto;">

    </div> -->

    <div class="group-footer l_text-center" v-if="isNonStandardHeight">

      <p>Your wardrobe will be manufactured at maximum height of 2750mm including the robe top.</p>

    </div>

  </div>

  <div class="group" :ref="refs[builder.tops.fieldName + 'Group']" :class="{'s_hidden' : !builder.showTopsOptions}">

    <div class="group-header" :id="`${builder.tops.fieldName}Title`">
      <div class="group-title">Your ceiling height is taller than our doors. <span>(2700mm)</span><br /><span>What kind of wardrobe top would you like?</span><br /><a href="https://mydiy.com.au/products/wardrobes/sliding-wardrobes/faqs/" target="_blank">Further details on our FAQ page</a></div>
    </div>

    <Selector
      :key=builder.tops.fieldName
      :field-name=builder.tops.fieldName
      :display-type=builder.tops.displayType
      :options=builder.tops.options
      :selected=builder.currentItem.specs[builder.tops.fieldName]
      options-source="topsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.tops.fieldName + 'Group']" :class="{'s_hidden' : !builder.showTopFillMessage}">

    <div class="group-header l_text-center" style="justify-content: center;" :id="`${builder.tops.fieldName}Title`">
      <div class="group-title">Due to your ceiling height, a pelmet is automatically included.<br /><span>Please build a bulkhead to meet our 2750mm height limit. <br /><a href="https://mydiywardrobes.com.au/support/faqs/" target="_blank">Further details on our FAQ page</a></span></div>
    </div>

  </div>

</template>

<script setup>

import { computed, ref } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const nonStandard = ref({
  width: false,
  height: false
});

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);
}

function updateValue(prop, val) {
  builder.setCurrentItemSpec(prop, val);
}

function updateNonStandard(prop, val) {
  nonStandard.value[prop] = val;
}

const isNonStandardHeight = computed(() => {
  if (nonStandard.value.height) return true;
  return false;
})

// init refs
let refHandles = [
  'widthGroup',
  builder.tops.fieldName + 'Group',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>
